import Phaser from 'phaser';

export default class GameOver extends Phaser.Scene {
    constructor() {
        super('gameover');
    }

    init(data) {
        this.totalScore = data.score;
        console.log(data.score);
    }

    create() {
        let self = this;
        //Add and play gameover sfx
        this.fade = this.add.rectangle(400, 800, 800, 1600, 0x000000, 0.5);
        this.panel = this.add.image(400, 800, 'ui', 'window-gameover');
        Phaser.Display.Align.In.Center(this.panel, this.fade);

        this.tweens.add({
            targets: self.panel,
            scale: 1,
            duration: 200,
            delay: 0,
            onComplete: function() {
                self.initPanel();
            }
        });
    }

    addText(x, y, str, tconfig) {
        let t = this.make.text(tconfig);
        t.setOrigin(0);
        t.x = x;
        t.y = y;
        t.text = str;
        return t;
    }

    //Init gameover panel
    initPanel() {
        let tconfig = { style: { fontSize: "200px", fontFamily: "dongle", color: "#e3242b", align: "center" } };

        this.scoreText = this.addText(0, 0, '0', tconfig);
        Phaser.Display.Align.In.Center(this.scoreText, this.panel, 0, 0);

        if (this.totalScore > 0) this.displayScore();
        else this.showButtons();
    }

    //Display score using text tween from 0 to score
    displayScore() {
        let score = this.totalScore;
        let self = this;

        this.scoreTween = this.tweens.addCounter({
            from: 0,
            to: score,
            duration: 2500,
            onComplete: function() {
                self.showButtons();
            },

            onUpdate: function() {
                self.scoreText.setText(Math.floor(self.scoreTween.totalProgress * score).toString());

                Phaser.Display.Align.In.Center(self.scoreText, self.panel, 0, 0);
            }
        });
    }

    //Show panel button
    showButtons() {
        let self = this;

        let playAgain = self.add.sprite(0, 0, 'ui', 'button-yes');
        playAgain.setInteractive().on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, function() {
            // self.sfx.stop();
            self.scene.start('game');
        });
        playAgain.on('pointerover', function() {
            playAgain.setScale(1.2);
            mainmenuButton.setScale(0.8);
        });
        playAgain.on('pointerout', function() {
            playAgain.setScale(1);
            mainmenuButton.setScale(1);
        });
        let mainmenuButton = self.add.sprite(0, 0, 'ui', 'button-no');
        mainmenuButton.setInteractive().on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, function() {
            // self.sfx.stop();
            self.scene.stop('game');
            self.scene.start('mainmenu');
        });
        mainmenuButton.on('pointerover', function() {
            playAgain.setScale(0.8);
            mainmenuButton.setScale(1.2);
        });
        mainmenuButton.on('pointerout', function() {
            playAgain.setScale(1);
            mainmenuButton.setScale(1);
        });

        //align Panels
        Phaser.Display.Align.In.Center(playAgain, self.panel, -130, 220);
        Phaser.Display.Align.In.Center(mainmenuButton, self.panel, 130, 220);
    }
}